import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const ContactInfo = ({ profile }) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-white">Información de Contacto</h3>
      <div className="space-y-3">
        <div className="flex items-center gap-3 text-slate-200 bg-slate-800/50 p-3 rounded-lg">
          <Mail size={20} className="text-blue-400 flex-shrink-0" />
          <span className="text-sm truncate">{profile.email}</span>
        </div>
        <div className="flex items-center gap-3 text-slate-200 bg-slate-800/50 p-3 rounded-lg">
          <Phone size={20} className="text-purple-400 flex-shrink-0" />
          <span className="text-sm">{profile.phone}</span>
        </div>
        <div className="flex items-center gap-3 text-slate-200 bg-slate-800/50 p-3 rounded-lg">
          <MapPin size={20} className="text-pink-400 flex-shrink-0" />
          <span className="text-sm">{profile.location}</span>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
